/**
 * GTM DataLayer helper — push eventów do Google Tag Manager
 * Konfiguracja tagów (GA4, Meta Pixel) w panelu GTM
 */
export function trackEvent(event, params = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
}

export const GTM = {
  signUp: (method = 'email') => trackEvent('sign_up', { method }),
  login: (method = 'email') => trackEvent('login', { method }),
  campaignCreated: (goal) => trackEvent('campaign_created', { campaign_goal: goal }),
  autoPublishEnabled: () => trackEvent('auto_publish_enabled'),
  autoPublishDisabled: () => trackEvent('auto_publish_disabled'),
  leadReceived: (source) => trackEvent('lead_received', { lead_source: source }),
  subscriptionStarted: (plan) => trackEvent('subscription_started', { plan_name: plan }),
  pagePublished: (platform) => trackEvent('post_published', { platform }),
  profileCompleted: (type) => trackEvent('profile_completed', { profile_type: type }),
  wizardStep: (step, name) => trackEvent('wizard_step', { step_number: step, step_name: name }),
};
